import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function Java_FAQ_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-5'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-5'>How many types of memory areas are allocated by JVM?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Many types:<br></br>Class(technique) area: elegance place shops per-class systems consisting of the runtime consistent pool, subject, technique facts, and the code for techniques.
          Heap: it’s miles the runtime records location wherein the reminiscence is allotted to the objects<br></br>
          Stack:<br></br>Java Stack stores frames. It holds local variables and partial outcomes, and plays a element in approach invocation and go back. Each thread has a personal JVM stack, created at the identical time because the thread. A brand new frame is created on every occasion a way is invoked. A body is destroyed when its approach invocation completes.
          Application Counter check in: pc (program counter) sign in incorporates the deal with of the Java digital system guidance presently being executed.<br></br>
          Native method Stack:<br></br>It incorporates all of the native methods used inside the utility.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What do you understand by Java virtual machine?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Java Virtual Machine is a virtual machine that enables the computer to run the Java program. JVM acts like a run-time engine which calls the main method present in the Java code. JVM is the specification which must be implemented in the computer system. The Java code is compiled by JVM to be a Bytecode which is machine independent and close to the native code.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What is JIT compiler?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Just-In-Time (JIT) compiler: It is used to improve the performance. JIT compiles parts of the bytecode that have similar functionality at the same time, and hence reduces the amount of time needed for compilation. Here the term “compiler” refers to a translator from the instruction set of a Java virtual machine (JVM) to the instruction set of a specific CPU.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
    </div>
  );
}
